// extracted by mini-css-extract-plugin
export default {"zoom__container":"zoomcontrol_zoom__container__3B9Qj","zoom__button":"zoomcontrol_zoom__button__3TDZh"};